import { useContext } from 'react';

import VerificationContext from './verification.context';

function useVerification() {
  const context = useContext(VerificationContext);

  if (!context) {
    throw new Error('useVerification must be used within VerificationContext');
  }

  return context;
}

export default useVerification;